// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** removes ugly yellow autofill indicator **/
input:-webkit-autofill
{
  -webkit-box-shadow: inset 0 0 0px 9999px cornflowerblue;
}

/* OTP input styling */
.otp-input {
  width: 44px;
  height: 48px;
  text-align: center;
  font-size: 20px;
  border-radius: 8px; /* Rounded corners */
  border: 1px solid #ced4da;
  box-shadow: none;
  padding: 0;
}

.otp-input:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, .25);
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
